import classNames from 'classnames';

import canAnswerFormBySteps from '../../lib/canAnswerFormBySteps';

import Form from '../forms/Form';
import FormSteps from '../forms/FormSteps';

import styles from '../../styles/blocks/form-block.module.css';

interface FormBlockProps {
    form: Form;
    className?: string;
}

function FormBlock({ form, className, ...props }: FormBlockProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                {canAnswerFormBySteps(form) ? (
                    <FormSteps form={form} />
                ) : (
                    <Form form={form} {...props} />
                )}
            </div>
        </div>
    );
}

export default FormBlock;
